export default "__VITE_ASSET__CRT2PeZJ__"